import { useEffect } from 'react';

/**
 * useReveal
 * ---------
 * Mirrors the IntersectionObserver behavior from the original
 * suite.jsx App component: any element with a `data-reveal`
 * attribute fades/translates into view when it scrolls into the
 * viewport (CSS handles the actual animation via the `.in` class
 * defined in base.css).
 *
 * Call once near the top of the page tree (e.g. <LandingPage>).
 */
export function useReveal() {
  useEffect(() => {
    const els = document.querySelectorAll('[data-reveal]');
    if (els.length === 0) return undefined;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            // Once revealed, stop observing — we don't need the animation
            // to replay on subsequent scroll-throughs.
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 },
    );

    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
}
